import { OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap";
import { Subject } from "rxjs";
import { moveItemInArray } from "@angular/cdk/drag-drop";
var CustomTagModalComponent = /** @class */ (function () {
    function CustomTagModalComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.action = 'save';
        this.dropdownOptions = [];
        this.formData = {};
        this.fieldType = '';
    }
    CustomTagModalComponent.prototype.ngOnInit = function () {
        this.onClose = new Subject();
        if (this.action == 'edit') {
            if (this.fieldType == 'dropdown') {
                this.formData.fieldType = this.fieldType;
                this.dropdownOptions = this.options;
            }
        }
    };
    CustomTagModalComponent.prototype.drop = function (event) {
        moveItemInArray(this.dropdownOptions, event.previousIndex, event.currentIndex);
    };
    CustomTagModalComponent.prototype.onSelectFieldType = function (ev) {
        this.formData['fieldType'] = ev.target.value;
    };
    CustomTagModalComponent.prototype.onAddOption = function () {
        if (this.formData.fieldType === 'dropdown' && this.formData.newOption) {
            this.dropdownOptions.push(this.formData.newOption);
            this.formData.newOption = ''; // Clear the input after adding
        }
    };
    CustomTagModalComponent.prototype.onRemoveOption = function (index) {
        this.dropdownOptions.splice(index, 1);
    };
    CustomTagModalComponent.prototype.saveCT = function () {
        var value = { fieldType: this.fieldType, options: this.fieldType === 'dropdown' ? this.dropdownOptions : null, action: this.action, value: this.value, denotationChar: '{' };
        this.onClose.next(value);
        this.bsModalRef.hide();
    };
    return CustomTagModalComponent;
}());
export { CustomTagModalComponent };
